import React from 'react'

const Sentiment = () => {
  return (
    <div>Sentiment</div>
  )
}

export default Sentiment